import React from 'react';

const FlagMsgNotPopup = ({ titleText, setNoFlagPopup }) => {
    return (
        <div className="backwrap">
            <div className="freeliModal">
                <div className="freeliModalHead">
                    <h4 className="popupTitle text-text-headings dark:text-text-light">{"No flagged messages yet."}</h4>
                    <span onClick={() => setNoFlagPopup(false)} className="closeModal text-text-body" data-for="rightSection_tooltip" data-tip="Close" currentitem="false"></span>
                </div>
                <div className="freeliModalBody">
                    <div className="delDesc dark:!bg-transparent">{"There are no flagged messages. When you flag a message, it will appear here."}</div>
                </div>
                <div className="freeliModalFoot">
                    <button onClick={() => setNoFlagPopup(false)} className="btnCancel">Close</button>
                </div>
            </div>
        </div>
    );
};

export default FlagMsgNotPopup;